import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import Api from "../../../../../Services/Api";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import {mapToObjectDDL} from "../../../../common/mapper";
import SimpleDateRange from "../../../../../modules/SimpleDateRange";
import M from "moment/moment";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import {fetchDataAsync} from "../../../../../Services/Utils";
import ErrorAction from "../../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {HttpStatus} from "../../../../common/Constants";

class FakturJualDGIFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            kabKotOptions: [],
            kecamatanOptions: [],
            kelurahanOptions: [],
            warnaOptions: [],
            unitTypeOptions: [],
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        const kabKotOptions = [];
        const unitTypeOptions = [];
        const res = await Promise.all([
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllCity,
                setError: this.props.setError,
                menuName: "Sales Order - Faktur Jual",
                args: "",
            }),
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllVariant,
                setError: this.props.setError,
                menuName: "Sales Order - Faktur Jual",
                args: "",
            })
        ]);

        res.forEach((response, idx) => {
            if (idx === 0) {
                if (res.ok && res.data.status !== HttpStatus.SUCCESS) this.props.onClickClose();
                if (response.data.status === HttpStatus.SUCCESS) {
                    kabKotOptions.push(...response.data.data.map(
                        d => mapToObjectDDL(d.kabKotName, d.kabKotId))
                    )
                }
            } else if (idx === 1) {
                if (res.ok && res.data.status !== HttpStatus.SUCCESS) this.props.onClickClose();
                if (response.data.status === HttpStatus.SUCCESS) {
                    unitTypeOptions.push(...response.data.data.map(
                        d => mapToObjectDDL(d.namaVariant, d.kodeVariant))
                    );
                }
            }
        });

        this.setState((prevState) => ({
            ...prevState,
            kabKotOptions,
            unitTypeOptions
        }));

        this.handleTriggerLoading();
    }

    handleValueChange = (name, value) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
            },
        }));
    };

    handleDateChange = (name, value) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
            },
        }));
    };

    handleKabKotChange = async (name, value) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
                kodeKecamatan: null,
                kecamatanOptions: [],
                kodeKelurahan: null,
                kelurahanOptions: [],
            },
        }));

        if (!R.isNil(value)) {
            const res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan,
                setError: this.props.setError,
                menuName: "Sales Order - Faktur Jual",
                args: value?.value,
            });

            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.setState((prevState) => ({
                    ...prevState,
                    kecamatanOptions: res.data.data.map(
                        (item) => mapToObjectDDL(item.kecamatanName, item.id)
                    ),
                }))
            }
        }
    }

    handleKecamatanChange = async (name, value) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
                kodeKelurahan: null,
                kelurahanOptions: [],
            },
        }));

        if (!R.isNil(value)) {
            const res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan,
                setError: this.props.setError,
                menuName: "Sales Order - Faktur Jual",
                args: value?.value,
            });

            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.setState((prevState) => ({
                    ...prevState,
                    kelurahanOptions: res.data.data.map(
                        (item) => mapToObjectDDL(item.kelurahanname, item.id)
                    ),
                }))
            }
        }
    }

    handleVarianChange = async (name, value) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
                kodeWarna: null,
                warnaOptions: [],
            },
        }));

        if (!R.isNil(value)) {
            const res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllWarnaByParam,
                setError: this.props.setError,
                menuName: "Sales Order - Faktur Jual",
                args: {paramFilters: {kodeVariant: value?.value}},
            });

            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.setState((prevState) => ({
                    ...prevState,
                    warnaOptions: res.data.data.map(
                        (item) => mapToObjectDDL(item.namaWarnaKomersil, item.id)
                    ),
                }))
            }
        }
    }

    handleClearFilter = () => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            filterData: {},
        }));
    };

    getDataValue(fieldName, fallbackValue = "") {
        return !R.isNil(this.props.state.filterData) && this.props.state.filterData[fieldName]
            ? this.props.state.filterData[fieldName]
            : fallbackValue;
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    render() {
        return (
            <>
                <SimpleModal
                    title="Filter Search"
                    visible={this.props.state.filterVisible}
                    onClickClose={this.props.onClickClose}
                    content={
                        <ModalContainer>
                            <FlexView column>
                                <SimpleDateRange
                                    label="Tanggal Invoice"
                                    startDateName="startTanggalInvoice"
                                    endDateName="endTanggalInvoice"
                                    data={this.props.state.filterData}
                                    onStartDateChange={(_, value) =>
                                        this.handleDateChange("startTanggalInvoice", M(value).format("DD-MM-YYYY"))
                                    }
                                    onEndDateChange={(_, value) =>
                                        this.handleDateChange("endTanggalInvoice", M(value).format("DD-MM-YYYY"))
                                    }
                                />
                                <SimpleInput
                                    id="input_text_dealer_id"
                                    name="dealerId"
                                    label="Dealer ID"
                                    value={this.getDataValue("dealerId")}
                                    onChange={({target}) => this.handleValueChange(target.name, target.value)}
                                />
                                <SimpleInput
                                    id="input_text_nomor_ktp"
                                    name="nomorKTP"
                                    label="Nomor KTP"
                                    value={this.getDataValue("nomorKTP")}
                                    onChange={({target}) => this.handleValueChange(target.name, target.value)}
                                />
                                <SimpleInput
                                    id="input_text_nama_customer"
                                    name="namaCustomer"
                                    label="Nama Customer"
                                    value={this.getDataValue("namaCustomer")}
                                    onChange={({target}) => this.handleValueChange(target.name, target.value)}
                                />
                                <SimpleInput
                                    id="input_text_alamat"
                                    name="alamat"
                                    label="Alamat"
                                    value={this.getDataValue("alamat")}
                                    onChange={({target}) => this.handleValueChange(target.name, target.value)}
                                />
                                <SimpleDDL
                                    id="select_options_kota"
                                    name="kodeKota"
                                    label="Kota"
                                    box="search"
                                    isClearable
                                    options={this.state?.kabKotOptions}
                                    value={this.getDataValue("kodeKota")}
                                    onChange={(value, {name}) => this.handleKabKotChange(name, value)}
                                />
                                <SimpleDDL
                                    id="select_options_kecamatan"
                                    name="kodeKecamatan"
                                    label="Kecamatan"
                                    box="search"
                                    isClearable
                                    options={this.state.kecamatanOptions}
                                    value={this.getDataValue("kodeKecamatan")}
                                    onChange={(value, {name}) => this.handleKecamatanChange(name, value)}
                                />
                                <SimpleDDL
                                    id="select_options_kelurahan"
                                    name="kodeKelurahan"
                                    label="Kelurahan"
                                    box="search"
                                    isClearable
                                    options={this.state.kelurahanOptions}
                                    value={this.getDataValue("kodeKelurahan")}
                                    onChange={(value, {name}) => this.handleValueChange(name, value)}
                                />
                                <SimpleDDL
                                    id="select_options_tipe_unit"
                                    name="kodeTipeUnit"
                                    label="Tipe Unit"
                                    box="search"
                                    isClearable
                                    options={this.state.unitTypeOptions}
                                    value={this.getDataValue("kodeTipeUnit")}
                                    onChange={(value, {name}) => this.handleVarianChange(name, value)}
                                />
                                <SimpleDDL
                                    id="select_options_kode_warna"
                                    name="kodeWarna"
                                    label="Kode Warna"
                                    box="search"
                                    isClearable
                                    options={this.state.warnaOptions}
                                    value={this.getDataValue("kodeWarna")}
                                    onChange={(value, {name}) => this.handleValueChange(name, value)}
                                />
                                <SimpleInput
                                    id="input_text_nomor_rangka"
                                    name="nomorRangka"
                                    label="Nomor Rangka"
                                    value={this.getDataValue("nomorRangka")}
                                    onChange={({target}) => this.handleValueChange(target.name, target.value)}
                                />
                                <SimpleInput
                                    id="input_text_nomor_mesin"
                                    name="nomorMesin"
                                    label="Nomor Mesin"
                                    value={this.getDataValue("nomorMesin")}
                                    onChange={({target}) => this.handleValueChange(target.name, target.value)}
                                />
                            </FlexView>
                            <FlexView hAlignContent="right" style={{gap: "10px"}}>
                                <SimpleButton text="Clear" onClick={this.handleClearFilter}/>
                                <SimpleButton text="Terapkan" onClick={this.props.onSubmit}/>
                            </FlexView>
                        </ModalContainer>
                    }
                />
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(FakturJualDGIFilter);
